/**
 * widgets/registry.network.tsx — Network (veřejné URL / platform access overview).
 */
import { Globe } from 'lucide-react';
import type { WidgetSpec } from './types';
import { NetworkOverviewPanel } from '../pages/modules/network/panels';

export const NETWORK_WIDGETS: WidgetSpec[] = [
  {
    id: 'network.overview',
    title: 'Public URLs',
    module: 'network',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Globe,
    since: '2.1.0',
    component: NetworkOverviewPanel,
  },
];
